import { render, staticRenderFns } from "./departmentModal.vue?vue&type=template&id=b2a0351c&scoped=true&"
import script from "./departmentModal.vue?vue&type=script&lang=js&"
export * from "./departmentModal.vue?vue&type=script&lang=js&"
import style0 from "./departmentModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./departmentModal.vue?vue&type=style&index=1&id=b2a0351c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a0351c",
  null
  
)

export default component.exports